{
    "api_keys": {
        "max_active": "Sie können höchstens {{max}} aktive Schlüssel haben. Widerrufen Sie einen, um einen neuen zu erstellen."
    },
    "vendor_cc_approver_needed": {
        "create_at_least_one": "Bitte erstellen Sie zuerst mindestens einen Lieferanten, Kostenstelle und eine:n potentielle:n Genehmiger:in."
    },
    "subscriptions": {
        "not_deletable_recurring": "Kann erst gelöscht werden, wenn alle wiederkehrenden Abonnements dieser Subscription gelöscht wurden.",
        "date_started_info": "Dieses Datum legt fest, ab wann finway den ersten wiederkehrenden Antrag erstellt. Alle weiteren wiederkehrenden Anträge richten sich nach diesem Datum."
    },
    "payment_subscription": {
        "need_to_be_cancelled_first": "Bitte deaktivieren Sie Ihr Zahlungsabonnement zuerst."
    },
    "limit_add_disabled": "Limits können nur hinzugefügt werden, wenn ein:e mögliche:r Genehmiger:in (Admin oder Genehmiger:in der selben Abteilung) bestimmt werden kann.",
    "export_button_tabs": {
        "select_at_least_one": "Bitte wählen Sie mindestens eine Ausgaben unten aus. Nur die ausgewählten Ausgaben werden exportiert."
    },
    "discount_expired": "Das Skonto ist abgelaufen. Bitte löschen Sie es manuell.",
    "expenses": {
        "credit_note_not_self_issued_receipt": "Eigenbelege können keine Gutschriften sein.",
        "credit_note_purchase_order_linked": "Mit einer Bestellung verknüpfte Belege können keine Gutschriften sein.",
        "document_type_locked_after_review": "Die Belegart kann nach der Prüfung nicht mehr geändert werden.",
        "not_editable_exported": "Eine bereits exportierte Ausgabe kann nicht mehr bearbeitet werden.",
        "purchase_order_link_credit_note": "Gutschriften können nicht mit Bestellungen verknüpft werden.",
        "smartcards_payments_detected_automatically": "Ausgaben, die Smartcards verwenden, erkennen Zahlungen automatisch.",
        "not_all_information_provided": "Es wurden nicht alle erforderlichen Informationen bereitgestellt.",
        "no_expense_selected": "Es wurde keine Ausgabe ausgewählt",
        "vendor_not_approved": "Lieferant ist nicht genehmigt.",
        "not_approved_yet": "Es sind noch nicht alle Ausgaben genehmigt.",
        "edit_disabled_due_to_beleg": "Die Bearbeitung dieses Antrags ist nicht möglich, da dieser als GoBD-konform gekennzeichnet ist. Alle Felder sind gesperrt und können nicht geändert werden.",
        "export_sepa_xml_disabled": "SEPA xml ist für Kartenanträge deaktiviert.",
        "export_non_sepa_xml_disabled": "NON-SEPA xml ist für Kartenanträge deaktiviert."
    },
    "reimbursement_types": {
        "standard": "Standard Rückerstattung",
        "standard_reimbursement": "Standard Rückerstattung",
        "mileage": "Rückerstattung Fahrtkosten",
        "hospitality": "Rückerstattung Bewirtung",
        "per_diem": "Rückerstattung Verpflegungsmehraufwand"
    },
    "vendor": {
        "incompatible_creditor_number": "Diese Kreditorennummer ist nicht kompatibel mit DATEV",
        "vendor_rule_inactive_due_to_settings": "Diese Regel ist inaktiv, da das entsprechende Feature in den Einstellungen deaktiviert ist.",
        "was_deleted": "Dieser Lieferant wurde am {{date}} gelöscht.",
        "name_short": "Offizieller Lieferantenname für DATEV-Konformität. Auf 50 Zeichen begrenzt. Dieser Name wird für Buchhaltung und Berichterstattung verwendet.",
        "name_extended_1": "Vollständiger Lieferantenname für",
        "name_extended_2": "und Zahlungsabwicklung. Erlaubt längere Namen über 50 Zeichen, um Warnmeldungen bei Zahlungen zu vermeiden.",
        "name_extended_link_label": "Verification-of-Payee (VoP)",
        "name_extended_link_url": "https://www.datev.de/web/de/nachrichten/gesetzliche-themen/payment-mit-datev/verification-of-payee/"
    },
    "read_direct_debit_agreement": "Bitte lesen Sie die Vereinbarung zur Lastschrift zu.",
    "default_role_cannot_be_deleted": "Diese Standard-Rolle kann nicht gelöscht werden.",
    "custom_bank_subject": "Der Verwendungszweck bei Überweisungen bestehet standartmäßig aus der Rechnungsnummer. Sie können den Verwendungszweck jedoch ergänzen, die Reihenfolge der Informationen festlegen und während des Überweisungsprozesses immer noch manuell anpassen.",
    "csv_template_settings": "Sie können benutzerdefinierte Vorlagen für den CSV-Export im Dashboard erzeugen, indem Sie Spalten entfernen, hinzufügen oder die Reihenfolge der Spalten in der Exportdatei ändern.",
    "csv_transaction_import": {
        "change_sign": "Insbesondere bei Amex-Zahlungen sind die Vorzeichen oft gegenteilig zu den tatsächlichen Daten. Mit Hilfe des Toggles können Sie die Vorzeichen in diesen Fällen umkehren.",
        "csv_name": "Benennen Sie Ihre CSV-Datei individuell für eine einfachere Zuordnung, z. B. \"PayPal\" oder \"Amex\". Bitte wählen Sie eine kurze Bezeichnung, da \"CSV\" weiterhin Bestandteil des Namens sein wird."
    },
    "expense_payment_flow_information": {
        "already_paid": "Zahlungsinfo: Bereits gezahlt.",
        "already_approved_and_paid": "Zahlungsinfo: Bereits genehmigt & gezahlt.",
        "reporting_only": "Zahlungsinfo: Nur Reporting."
    },
    "vendorRulesShouldOverwrite": "Standardmäßig überschreiben Mitarbeiterregeln Lieferanten-Regeln. Mit dieser Einstellung können Sie das ändern. Werte werden einzeln überschrieben. Wenn z.B. Kostenstelle 1 in den Lieferanten-Regeln nicht gesetzt ist, obwohl diese die Mitarbeiterregeln überschreiben sollten, so wird dieser Wert von den Mitarbeiterregeln genommen, sofern er dort gesetzt ist.",
    "adjacent_request": {
        "previous": "Vorheriger Antrag im Status ",
        "next": "Nächster Antrag im Status ",
        "purchase_approval_needed": "Einkaufsfreigabe",
        "invoice_approval_needed": "Rechnungsfreigabe",
        "approval_pending": "Freigabe ausstehend",
        "docs_needed": "Dateien erforderlich",
        "in_review": "in Prüfung",
        "reviewed": "geprüft",
        "paid": "bezahlt",
        "in_progress": "in Bearbeitung",
        "done": "Erledigt",
        "all": "Alle"
    },
    "datev": {
        "information_customisation": "Prüfen Sie die voreingestellten Informationen, die als Notiz & Buchungstext an DUO übermittelt werden oder passen Sie diese an",
        "subscription": "Antragsart wird als \"Abonnement\" exportiert",
        "reimbursement_items": "Rückerstattungsart wird z.B. als \"Rückerstattung\", \"Kilometerpauschale\" exportiert.\n Bewirtungsrückerstattungen werden immer mit \"Bewirtung\" + Namen der Teilnehmer:innen exportiert"
    },
    "debit_card_limit_buffer": "Wählen Sie Ihren Standard-Limit-Puffer (%), um mögliche Transaktionsablehnungen zu vermeiden.",
    "hospitality": {
        "total_calculated_amount": "Die Gesamtbeträge werden auf Basis der Artikel automatisch berechnet"
    },
    "mileage": {
        "add_stop": "Zusätzlicher Halt wird direkt unter dieser Adresse eingefügt.",
        "distance_buffer": "Definition eines Puffers in km, den Nutzer:innen manuell - ohne Angabe eines Grundes - zur berechneten Entfernung hinzufügen können.",
        "total_calculated_amount": "Die Gesamtbeträge werden auf Basis der Artikel automatisch berechnet",
        "distance": "Automatisch berechnet auf Basis der optimalen Route und auf volle Kilometer abgerundet"
    },
    "per_diem": {
        "total_calculated_amount": "Erstattungsfähiger Gesamtbetrag berechnet sich automatisch auf Basis Ihrer Eingaben"
    },
    "expense_reminder": "Wiedervorlage erstellt für den {{date}}",
    "reports": {
        "refresh": "Aktualisiert Daten"
    },
    "approval_process": {
        "has_approved_request_on": "{{name}} hat diesen Antrag am {{date}} genehmigt.",
        "has_rejected_request_on": "{{name}} hat diesen Antrag am {{date}} abgelehnt.",
        "has_approved_request_on_for": "{{name}} hat diesen Antrag für {{approverName}} am {{date}} genehmigt.",
        "has_rejected_request_on_for": "{{name}} hat diesen Antrag für {{approverName}} am {{date}} abgelehnt.",
        "no_right": "Sie besitzen nicht die notwendigen Rechte um diesen Antrag freizugeben."
    },
    "fallback_approver": "Definieren Sie den Fallback-Genehmiger, der verwendet werden soll, um Workflows in bestimmten Fällen zu entsperren.",
    "recalculate_approval_processes_in_progress": "Die von diesem Workflow erstellten Genehmigungsprozesse werden neu berechnet. Der Genehmigungsprozess wird neu gestartet und alle aktuellen Genehmigungen werden zurückgesetzt.",
    "recalculate_approval_process_after_amount_changes": "Wenn sich der Betrag in Anträgen mit aktivem Freigabeprozess verändert, führt eine Aktivierung dieser Einstellung zu einer Zurücksetzung der bisherigen Freigaben. Zudem wird berechnet, ob ein besser passender Freigabeprozess durch die Änderung erforderlich wird.",
    "recalculate_approval_process_after_folder_amount_changes": "Wenn sich der Betrag in Anträgen mit aktivem Freigabeprozess verändert, führt eine Aktivierung dieser Einstellung zu einer Zurücksetzung der bisherigen Freigaben. Zudem wird berechnet, ob ein besser passender Freigabeprozess durch die Änderung erforderlich wird.",
    "recalculate_approval_process_after_other_changes": "Wenn sich Lieferant, Kostenstelle 1 oder 2 oder der Anforderer in Anträgen mit aktivem Freigabeprozess verändert, führt eine Aktivierung dieser Einstellung zu einer Zurücksetzung der bisherigen Freigaben. Zudem wird berechnet, ob ein besser passender Freigabeprozess durch die Änderung erforderlich wird.",
    "recalculate_approval_process_after_folder_other_changes": "Wenn sich Kostenstelle 1 oder 2 oder der Antragsteller in Reisen mit aktivem Freigabeprozess verändert, führt eine Aktivierung dieser Einstellung zu einer Zurücksetzung der bisherigen Freigaben. Zudem wird berechnet, ob ein besser passender Freigabeprozess durch die Änderung erforderlich wird.",
    "employee": {
        "was_deleted": "Dieser Nutzer wurde am {{date}} gelöscht"
    },
    "vat": {
        "disabled_tax_rate_input": "Dieser Steuersatz (%) wird aktiv in Anträgen genutzt und kann nicht verändert werden, um Betragskalkulationen nicht zu beeinträchtigen. Bitte legen Sie einen neuen Steuersatz an. ",
        "was_deleted": "Dieser Steuersatz (%) wurde am {{date}} gelöscht.",
        "default_not_deletable": "Der Standard MwSt.-Satz kann nicht gelöscht werden."
    },
    "cost_center": {
        "was_deleted": "Diese Kostenstelle wurde am {{date}} gelöscht."
    },
    "cost_center_2": {
        "was_deleted": "Diese Kostenträger wurde gelöscht."
    },
    "expense_account": {
        "was_deleted": "Dieses Sachkonto wurde gelöscht."
    },
    "invoice_auto_matching_feature": "Wenn aktiviert, werden Rechnungen und Anträge mit einer Matching-Wahrscheinlichkeit von 100% automatisch gematcht.",
    "ocr_hint": "OCR muss aktiviert sein um Rechnungen (inkl. E-Rechnungen) auszulesen.",
    "status": "Status",
    "sso": {
        "description": "Verwalten Sie Ihre Single Sign-On (SSO) einstellungen",
        "enforce": "Alle Nutzer werden ab dem nächsten Login aufgefordert sich mit SSO zu authentifizieren. Es werden keine Daten verloren gehen."
    },
    "mfa": {
        "enforce": "Alle Nutzer werden beim nächsten Login aufgefordert MFA aktiv für jeden Login zu nutzen."
    },
    "folder": {
        "attach_empty": "Bitte wählen Sie mind. 1 Antrag.",
        "sub_expense_status_left_behind": "Reise kann nicht freigegeben werden, da noch nicht alle enthaltenen Anträge im korrekten Status sind.",
        "single_sub_expense_status_left_behind": "Dieser Ausgabenstatus steht hinter dem Reisestatus.",
        "sub_expense_step_left_behind": "Dieser Antragsgenehmigungsschritt liegt hinter dem Reisegenehmigungsschritt.",
        "sub_expense_approval_left_behind": "Diesen Antrag erfordert mehr Genehmigungen, um mit den Reisegenehmigungen übereinzustimmen.",
        "sub_expense_approval_missing_vendor": "Lieferant fehlt",
        "sub_expense_approval_missing_cost_center": "Kostenstelle fehlt.",
        "unsubmitted_invoice": "Nicht eingereichte Rechnung."
    },
    "shared_expense_tooltip": {
        "shared_multiple": "Geteilt von mehreren Mitarbeiter:Innen",
        "shared": "Geteilt von"
    },
    "vendor_trigger_type_do_not_apply_to_mileage_and_per_diem": "Der Lieferanten-Auslösetyp wird nicht auf Verpflegungsmehraufwands- und Fahrtkostenerstattungen angewandt.",
    "approval_process_will_apply_to_recurring_expenses": "Dieses Master-Abonnement wird automatisch freigegeben. Dieser Freigabeprozess wird auf die wiederkehrenden Anträge angewendet.",
    "synch_expenses": {
        "user": "Nutzer:innen-Änderungen in bestehenden Anträgen synchronisieren (bezieht sich nicht auf Name und E-Mail).",
        "vendor": "Lieferantenänderungen in bestehenden Anträgen synchronisieren.",
        "vat": "Änderungen an Steuersatz oder -schlüssel in bestehenden Anträgen synchronisieren.",
        "expense_account": "Sachkontenänderungen in bestehenden Anträgen synchronisieren."
    },
    "cards": {
        "bin_type_physical": "Deutsche BIN ist für physische Karten noch nicht verfügbar.",
        "bin_type_virtual": "Karten mit einer deutschen BIN haben eine bessere Akzeptanzrate, sind jedoch momentan nur für virtuelle Karten ohne Apple Pay und Google Pay verfügbar."
    },
    "root_company_not_deletable": "Hauptfirma kann nicht gelöscht werden",
    "inbox_invoice": {
        "unassigned": "Nicht zugewiesen",
        "assigned": "Zugewiesen: {{name}}"
    },
    "personio": {
        "upload_csv": "CSV Upload",
        "include_user": "Nutzer:in einschließen",
        "contact_support_to_enable": "Bitte kontaktieren Sie den Support, um die Integration zu aktivieren",
        "team_source": "Diese Abteilung wurden von Personio importiert"
    },
    "datev_csv_config": {
        "wallet_account": "Bitte geben Sie hier das Sachkonto, das Ihr finway Wallet (das Kartenguthaben) in der Buchhaltung abbildet, z.B. ein Unterkonto von 1200 (SKR 03) oder 1800 (SKR 04).",
        "cash_transit_account": "Verrechnungskonto für die Aufladung des finway Wallets, z.B. 1360 (SKR 03), 1460 (SKR 04) oder verfügbare Unterkonten.",
        "account_number_length": "Bitte geben Sie die Nummernlänge der Sachkonten an. Wert muss mit der Konfiguration des Mandats in DATEV übereinstimmen.",
        "config_missing": "Die Einstellungen für die DATEV Buchungsstapel Datei sind noch nicht eingerichtet."
    },
    "datev_wallet_csv_statement_not_existing": "Es wurde bisher keine Datei erstellt. Regenerieren Sie die Datei zuerst über die drei Punkte rechts.",
    "company_settings": {
        "vendor_payment_netting": "Die Lieferantenverrechnung fasst offene Rechnungen eines Lieferanten zu einer einzelnen Zahlung zusammen und verrechnet dabei vorhandene Gutschriften.",
        "employee_default_language": "Neue Benutzer:innen beginnen mit dieser Standardsprache, können sie aber später in ihren Einstellungen ändern.",
        "time_zone": "Die Zeitzone ist ausschlaggebend für alle zeitbezogenen Daten in finway. Bitte kontaktieren Sie den Support, um die Zeitzone für diese Firma anzupassen.",
        "auto_matching_feature": "Automat. Matching von Transaktionen verknüpft Anträge automatisch mit den entsprechenden importierten Banktransaktionen. Wenn ein Antrag bereits vor der Prüfung automatisch einer Transaktion zugeordnet wird, überspringt er nach der Prüfung die Zahlungsphase, da er bereits als bezahlt gilt. Wenn ein Antrag während der Zahlungsphase automatisch einer Transaktion zugeordnet wird, wechselt er automatisch in den Status „Zu exportieren“, und wenn der automatische Export aktiviert ist, wird er sofort exportiert und als „Erledigt“ markiert."
    },
    "export_change_history": {
        "no_roles_access": "Sie benötigen Systemadministrationsrechte, um diese Ressource auszuwählen."
    },
    "setting_scope": {
        "company": "Diese Einstellung wirkt sich nur auf diese Firma aus.",
        "global": "Diese Einstellung ist global und gilt für alle Ihre Firmen."
    },
    "employee_absence": {
        "substituted_by": "Wegen Abwesenheit vertreten durch: {{substitutedBy}}",
        "substituted_by_with_timeframe": "{{substitutedBy}} vertritt {{approver}} vom {{startDate}} bis zum {{endDate}}.",
        "substituted_by_you_with_timeframe": "Sie vertreten {{approver}} vom {{startDate}} bis zum {{endDate}}.",
        "approver_name_you": "Sie"
    },
    "ai_ocr_hint": "Mit unserer KI-OCR erfassen Sie Text schnell und präzise. Manchmal können kleine Fehler auftreten - bitte kontrollieren Sie wichtige Details.",
    "ocr_disabled_hint": "OCR ist deaktiviert, da dieser Lieferschein verknüpfte Positionen enthält.",
    "delivery_note_fully_linked_hint": "Alle Positionen des Lieferscheins sind bereits verknüpft.",
    "purchase_order": {
        "not_editable": {
            "approved": "Genehmigte Bestellungen können nicht geändert werden, um Preis- und Datenkorrektheit sicherzustellen."
        }
    },
    "workflow": {
        "net_amount": "Es wird nur der absolute Betrag berücksichtigt. Erstattungen (negative Beträge) können diesen Workflow ebenfalls auslösen."
    },
    "po_skip_procurement": "Wenn aktiviert, wird der PO-Einkaufsprozess übersprungen und die Bestellung automatisch freigegeben.",
    "action_disabled": "Sie können diese Aktion nicht durchführen, da die Funktion für Ihr Unternehmen deaktiviert wurde. Wenn Sie Zugriff benötigen, wenden Sie sich bitte an Ihren Administrator.",
    "changes_requested": "Änderungen angefordert",
    "vendor_payments": {
        "pending_credit_notes": "Die Gutschriften {{expenseNumbers}} dieses Lieferanten sind noch nicht freigegeben. Sie müssen geprüft werden, bevor sie verrechnet werden können."
    }
}
